import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Field, Form, formValueSelector, reduxForm, change } from 'redux-form/immutable';
import { useSelector, useDispatch } from 'react-redux';
import * as parsers from 'utils/reduxForm/parsers';
import moment from 'utils/moment';
import PersonalInfoGP3Container from 'modules/Taps/containers/PersonalInfoGP3Container';
import personalInfoFields from 'modules/Taps/components/PersonalInfoGP3/fieldsConfig';
import renderDateField from 'components/DateField/reduxFormDateField';
import renderCheckboxField from 'components/Checkbox/reduxForm';
import renderField from 'components/Field/reduxForm';
import Checkbox from 'components/Checkbox/index';
import Button from 'components/Button';
import Card from 'components/Card/CardNew';

const formName = 'armyMeasuresForm';

function ArmyMeasuresForm(props) {
  const { handleSubmit, autofill, privileges } = props;
  const dispatch = useDispatch();
  const [touched, setTouched] = useState(false);

  const mobilizationDate = useSelector((state) => {
    return formValueSelector(formName)(state, 'mobilizationDate');
  });

  const allChecked = useSelector((state) => {
    for (let i = 0; i < privileges.length; i++) {
      const { id } = privileges[i];
      if (!formValueSelector(formName)(state, id)) {
        return false;
      }
    }
    return true;
  });

  const hasChecked = useSelector((state) => {
    for (let i = 0; i < privileges.length; i++) {
      const { id } = privileges[i];
      if (formValueSelector(formName)(state, id)) {
        return true;
      }
    }
    return false;
  });

  const checkAll = useCallback(() => {
    const newVal = !allChecked;
    privileges.map(({ id }) => {
      dispatch(change(formName, id, newVal));
    });
    setTouched(true);
  });

  return (
    <Form onSubmit={handleSubmit}>
      <div>
        <div className={'H2 pt-3'}>Сообщить об отсутствии мер поддержки</div>

        <Card className={'mt-3 mb-3 p-3'}>
          <PersonalInfoGP3Container
            autofill={autofill}
            needAutofill={true}
            fields={[
              personalInfoFields.inn,
              personalInfoFields.lastName,
              personalInfoFields.firstName,
              personalInfoFields.middleName,
            ]}
            parentFormName={formName}
            showRequiredMessage={false}
            isOpen={false}
          />
          <Field
            minDate={moment.fromServerDatetime('2022-02-24')}
            maxDate={moment()}
            label={'Дата мобилизации'}
            name={'mobilizationDate'}
            component={renderDateField}
            parse={parsers.momentParser}
          />
          <Field
            minDate={
              (mobilizationDate && moment(mobilizationDate).add(1, 'd')) ||
              moment.fromServerDatetime('2022-02-24')
            }
            maxDate={moment()}
            label={'Дата демобилизации'}
            name={'demobilizationDate'}
            validate={(value) => {
              if (mobilizationDate >= value) {
                return 'Дата демобилизации должна быть позднее даты мобилизации';
              }

              if (value > moment()) {
                return 'Дата демобилизации не может быть позднее текущей даты';
              }
              return null;
            }}
            component={renderDateField}
            parse={parsers.momentParser}
          />
          <Field
            label="Серия и номер военного билета"
            name="militaryId"
            component={renderField}
            placeholder="ББ XXXXXX0"
            normalize={(val, prevVal) => {
              let normalizedValue = val.trim().toUpperCase() || '';
              if (normalizedValue.length > 10) {
                return prevVal;
              }
              if (normalizedValue.length > 2 && normalizedValue[2] !== ' ') {
                const letters = normalizedValue.substring(0, 2);
                const numbers = normalizedValue.substring(2, normalizedValue.length);
                normalizedValue = `${letters} ${numbers}`;
              }
              return normalizedValue;
            }}
            validate={(val) => {
              if (val && !val.match(/^[А-Я]{2} \d{6,7}$/)) {
                return 'Серия и номер военного билета должны быть в формате ББ XXXXXX0 (где Б - любая заглавная буква кириллицы, Х - обязательная цифра, 0 - необязательная цифра)';
              }
              return null;
            }}
          />
          <div className={'H2 pb-3'}>Выберите меры поддержки</div>

          <Checkbox
            value={allChecked}
            label="Выбрать все"
            onChange={checkAll}
            isValid={hasChecked}
            validationMessage={
              touched && !hasChecked
                ? 'Выберите хотя бы одну меру поддержки, которая отсутствует в личном кабинете'
                : null
            }
          />

          {privileges.map(({ id, description }) => {
            return (
              <Field
                value={id}
                key={id}
                name={id}
                label={description}
                onChange={() => {
                  setTouched(true);
                }}
                component={renderCheckboxField}
              />
            );
          })}

          <Button type={'submit'} isDisabled={!hasChecked}>
            Отправить
          </Button>
        </Card>
      </div>
    </Form>
  );
}

export default reduxForm({
  form: formName,
})(ArmyMeasuresForm);

ArmyMeasuresForm.propTypes = {
  handleSubmit: PropTypes.func,
  privileges: PropTypes.array.isRequired,
  autofill: PropTypes.func.isRequired,
};
